import React, { Component } from 'react';

//IMPORT REDUX
import { connect } from 'react-redux';
import {
    addCalculResult,
    addCalculHistorique,
    addModalHistorique,
    addToList,
    addCalculError
} from '../../../redux/actions/ConfigFileAction'

import Exit from '../../../assets/svg/Exit.svg';

import API from '../../../services/api';

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Grid,
    Segment,
    Item,
    Form,
    Button,
    Container,
    Divider,
    Icon,
    Modal,
    Header,
    Image,
    Select,
} from 'semantic-ui-react';

import './modalHistorique.css'


import { translate } from "react-translate";


const mapStateToProps = state => ({
    app: state.app,
    configfile: state.configfile
})

const mapActionToProps = {
    addCalculResult: addCalculResult,
    addCalculHistorique: addCalculHistorique,
    addModalHistorique: addModalHistorique,
    addToList: addToList,
    addCalculError: addCalculError

}


class ConnectedModalHistorique extends Component {
    constructor(props) {
        super(props);

        this.addCalculHisto = this.addCalculHisto.bind(this)
        this.addCalculResult = this.addCalculResult.bind(this)
        this.addModalHistorique = this.addModalHistorique.bind(this)
        this.addToList = this.addToList.bind(this)
        this.addCalculError = this.addCalculError.bind(this)

    }

    addCalculHisto(calcHisto) {
        this.props.addCalculHistorique(calcHisto)
    }

    addCalculResult(calculResult) {
        this.props.addCalculResult(calculResult)
    }

    addModalHistorique() {
        this.props.addModalHistorique(false)
    }

    addToList(atl) {
        this.props.addToList(atl)
    }

    addCalculError(bool) {
        this.props.addCalculError(bool)
    }

    handleCalcHistoSelect(e, content) {
        e.preventDefault();

        this.addModalHistorique()

        this.addToList(true);
        this.addCalculError(false);
				let historyContent = JSON.parse(content.variable)
        this.addCalculResult(historyContent);
				this.props.onChangeCalcHistoryCallback(historyContent);
    }

    render() {


        const { t } = this.props;

        return (
            <div>
                <Modal
                    open={this.props.configfile.modal_historique}
                    onClose={this.addModalHistorique}
                    size='tiny'
                >
                    <Modal.Header id="modalHeader">
                        <Grid>
                          <Grid.Row>
                            <Grid.Column textAlign='center'>
                                <Image
                                  id="modalExit"
                                  onClick={this.addModalHistorique}
                                  src={Exit}
                                  floated='right' />
                                <Header
                                  as='h2'
                                  id="modalTitle"
                                  textAlign='center'>
                                  {t("title")}
                                </Header>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                    </Modal.Header>

                    <Modal.Content id="sortBy">
                      <Grid>
                        <Grid.Row columns={2}>
                          <Grid.Column width={8}>
                            <h2>
                              <Icon name='sort content descending' />
                              <span>Trier par</span>
                            </h2>
                          </Grid.Column>
                          <Grid.Column width={8}>
                            <Select  defaultValue='Date' options={[{value:'Date', text: 'Date'}]} />
                          </Grid.Column>
                          </Grid.Row>
                      </Grid>
                      </Modal.Content>


                    <Modal.Content style={{ backgroundColor: '#f9f9f9' }}>
                        <Grid
                            textAlign='center'
                            style={{ height: '100%' }}
                            verticalAlign='middle'
                        >
                            <Grid.Column>
                                <Header as='h5' >
                                    {
                                        this.props.configfile.calculHisto != null ? (
                                            Object.entries(this.props.configfile.calculHisto).map((key, Mainindex) => {
                                                if (Mainindex === parseInt(key[0])) {
                                                    let date
                                                    Object.entries(key[1].created_time).map((key, Mainindex) => {
                                                        if (key[0] === "date") {
                                                            date = key[1].split('.')[0]
                                                        }
                                                    })
                                                    return (
                                                        <Segment key={1} onClick={(e) => this.handleCalcHistoSelect(e, key[1])} style={{ cursor: "pointer", border: '1px solid #d2d2d2', borderRadius: '7px' }} >
                                                            <Grid>
                                                                <Grid.Row columns={3} style ={{  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.13)' }}>
                                                                    <Grid.Column verticalAlign='middle' width={2}>
                                                                        <Icon name='calculator' style={{ color: 'rgb(200, 200, 200)', fontSize: '1.5em' }}/>
                                                                    </Grid.Column>
                                                                    <Grid.Column verticalAlign='middle' width={9} style={{ color: 'rgb(86, 86, 86)', fontSize: '1.5em' }}>
                                                                        {date}
                                                                    </Grid.Column>
                                                                    <Grid.Column width={5} >
                                                                        <Button
                                                                          onClick={(e) => this.handleCalcHistoSelect(e, key[1])}
                                                                          size='small'
                                                                          id="smallBtn">
                                                                          {t('re_use')}
                                                                        </Button>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            </Grid>
                                                        </Segment>
                                                    )
                                                }
                                            })
                                        ) : (
                                                <div></div>
                                            )
                                    }
                                </Header>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </Modal>
            </div>
        )

    }
}

const ModalHistorique = connect(mapStateToProps, mapActionToProps)(ConnectedModalHistorique);
export default translate("ModalHistorique")(ModalHistorique);



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/ModalHistorique.jsx